module.exports = __webpack_public_path__ + "img/RX-Arcos-6.c58a7e9a.png";